var _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitoredCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.37793,
    y: 1.31641,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.37793,
    y: 1.31641,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#CF19A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.87793,
    cy: 8.81641,
    r: 4,
    fill: "#CF19A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoredCircle);
export default __webpack_public_path__ + "static/media/monitored_circle.e700c3fce2513a53c23934f8ca691b8c.svg";
export { ForwardRef as ReactComponent };